import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import ASULogo from 'assets/ASU.png'
import Header from 'components/common/SevenScreenHeader/Header'
import { makeStyles } from '@mui/styles'
import Screen from '../../7screen/Screen1/Screen1'

const useStyles = makeStyles({
    screenWrapper: {
        width: '100%',
        height: '100%',
    },
    screenContentWrapper: {
        backgroundImage: 'linear-gradient(to bottom, #00599B, #002D4E)',
        color: '#fff',
        width: '100%',
        height: 'calc(100% - 83px)',
        textAlign: 'center',
        alignContent: 'center',
    },
})

const Screen1 = () => {
    const classes = useStyles()

    return (
        // <Box className={classes['screenWrapper']}>
        //     <Header title="Screen 1" srcLogo={ASULogo} showProfile={true} />
        //     <main className={classes['screenContentWrapper']}>Screen 1</main>
            <Screen/>
        // </Box>
    )
}

export default Screen1
